module.exports = __webpack_public_path__ + "img/kruisje-modal.d37fd53cf0972e162fb562e1b7e1f405.svg";